module.exports = __webpack_public_path__ + "img/baie-mont-saint-michel-medium.42be3fff.jpg";